import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AdminComponent } from './admin.component';
import { DashBoardComponent } from './dashboard/dashboard.component';
import { AuthGuard } from '../app.guard';
import { ProfileComponent } from './profile/profile.component';
import { MenuMangeComponent } from './menumange/menumange.component';
import { BannerComponent } from './banner/banner.component';
//import { ProductsModule } from './products/products.module';
import { FooterComponent } from './footer/footer.component';
import { InfoPublicComponent } from './infopublic/infopublic.component';
import { LinkAliasComponent } from './linkalias/linkalias.component';
import { MetatagComponent } from './metatag/metatag.component';
import { OrderComponent } from './order/order.component';
//import { PageModule } from './page/page.module';

const routes: Routes = [
  {
    path: 'admin', component: AdminComponent,
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'prefix' },
      { path: 'dashboard', component: DashBoardComponent, canActivate: [AuthGuard] },
      { path: 'profile', component: ProfileComponent, canActivate: [AuthGuard] },
      { path: 'infopublic', component: InfoPublicComponent, canActivate: [AuthGuard] },
      { path: 'banner', component: BannerComponent, canActivate: [AuthGuard] },
      { path: 'footer', component: FooterComponent, canActivate: [AuthGuard] },
      { path: 'menumange', component: MenuMangeComponent, canActivate: [AuthGuard] },
      {
        path: 'products',
        loadChildren: './products/products.module#ProductsModule'
      },
      { path: 'linkalias', component: LinkAliasComponent, canActivate: [AuthGuard] },
      { path: 'metatag', component: MetatagComponent, canActivate: [AuthGuard] },
      {
        path: 'page',
        loadChildren: './page/page.module#PageModule'
      },
      { path: 'order', component: OrderComponent, canActivate: [AuthGuard] },
      {
        path: 'tool',
        loadChildren: './tool/tool.module#ToolModule'
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/admin/admin-routing.module.ts